import React, { FC, useCallback } from 'react';
import { useLogger } from '@direct-frontend/modules-logger';
import { genericMemo } from '@direct-frontend/stdlib';

import { cn } from '../../../lib/css/className/className';
import { ClickableIcon } from '../../ClickableIcon';
import { IconArrowLeft, IconArrowRight } from '../../../icons';
import { useSidebarCollapsedState } from '../SidebarCollapsedStateProvider';

import { i18n } from './SidebarExpandButton.i18n';
import './SidebarExpandButton.css';

const cnSidebarExpandButton = cn('SidebarExpandButton');

/** Свойства компонента SidebarExpandButton */
export type SidebarExpandButtonProps = {
    /**
     * Дополнительный css-класс для корневого элемента
     */
    className?: string;
};

/**
 * Кнопка для переключения между свернутым и развернутым состоянием для Sidebar
 * @kind component
 * */
export const SidebarExpandButton: FC<SidebarExpandButtonProps> = genericMemo(function SidebarExpandButtonProps({
    className,
}) {
    const { LogProvider } = useLogger('SidebarExpandButton');

    const { isCollapsed, onToggleIsCollapsed } = useSidebarCollapsedState();
    const onClick = useCallback(() => {
        onToggleIsCollapsed();
    }, [onToggleIsCollapsed]);

    const title = isCollapsed ? i18n('Развернуть') : i18n('Свернуть');

    return (
        <LogProvider>
            <div className={cnSidebarExpandButton(null, [className])}>
                <ClickableIcon
                    className={cnSidebarExpandButton('icon', { collapsed: isCollapsed })}
                    data-testid={'SidebarExpandButton'}
                    logNode={isCollapsed ? 'Expand' : 'Collapse'}
                    onClick={onClick}
                    title={title}
                >
                    {isCollapsed ? <IconArrowRight size="16" /> : <IconArrowLeft size="16" />}
                </ClickableIcon>
            </div>
        </LogProvider>
    );
});
